import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useUpvotySurvey } from 'Hooks/Common';
import { useGoogleClientIdUpdate } from 'Hooks/User';
import { WrapperProps } from 'Interfaces/Common';
import { User } from 'Interfaces/User';
import { pick } from 'lodash-es';
import { selectUser } from 'Utils/selectors';

import RootWrapper from './RootWrapper';

const userSurveryFields = ['email', 'name', 'id'] as const;

const UserAuthenticatedWrapper = ({ children }: WrapperProps) => {
  const { clientId, ...userData }: User = useSelector(selectUser);
  const [updateGoogleClientId] = useGoogleClientIdUpdate();

  useEffect(() => {
    if (!clientId) {
      updateGoogleClientId(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useUpvotySurvey(pick(userData, userSurveryFields));

  return <RootWrapper>{children}</RootWrapper>;
};

export default UserAuthenticatedWrapper;
